import React, { useEffect, useState } from 'react';
import { Col, Row, Tabs } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectOverviewFilter, selectPopup,
  selectMyEngagementHeadersContainerCompanies,
  selectMyEngagementDetailContainerCompanies,
  selectMyEngagementDetailContainerPeople,
  selectMyEngagementDetailContainerAlerts,
  selectMyEngagementHeadersContainerPeople,
  selectMyEngagementHeadersContainerAlerts,
  selectMyEngagaementCompanyLoading,
  selectMyEngagaementPeopleLoading,
  selectMyEngagaementAlertsLoading,
  selecthasMoreCompany,
  selecthasMorePeople,
  selecthasMoreAlert,
  selectUserCompanyFetchMoreLoading,
  selectUserPeopleFetchMoreLoading,
  selectUserAlertFetchMoreLoading,
} from 'Selector/SRISelector';
import { actions as SRIActions } from 'Slice/SRISlice';
import { actions as FavouriteActions } from 'Slice/FavoriteArticlesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  SRICompanyDetails, SRIContentDetails, SRIFilters, SRIPersonDetails,
} from 'Types/SRITypes';
import { PersonalityTypes } from 'Types/PersonTypes';
import { UpdatePersonProfileFollow } from 'Types/RequestBodies';

import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import ProfilePopups from 'Components/common/modal/ProfilePopups';
import { AddCompanyPopup } from 'Types/CompaniesTypes';
import { SRI_FILTER_TYPES_USER } from 'Utils/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import DocumentHubTableSkeleton from 'Components/common/skeleton/DocumentHubTableSkeleton';
import EngagementProfileStats from './EngagementProfileStats';
import EngagementTitle from './EngagementTitle';
import EngagementPeopleTableHeader from './EngagementPeopleTableHeader';
import EngagementPeopleTableBody from './EngagementPeopleTableBody';
import EngagementCompanyTableHeader from './EngagementCompanyTableHeader';
import EngagementCompanyTableBody from './EngagementCompanyTableBody';
import EngagementContentTableHeader from './EngagementContentTableHeader';
import EngagementContentTableBody from './EngagementContentTableBody';

const Wrapper = styled.div`
  .engagement-child-tabs {
    .ant-tabs-tab {
      &:first-child {
        .ant-tabs-tab-btn {
          border-radius: 8px 0px 0px 8px !important;
        }
      }
      &:nth-child(2) {
        .ant-tabs-tab-btn {
          border-radius: 0px !important;
        }
      }
      &:nth-child(3) {
        .ant-tabs-tab-btn {
          border-radius: 0px 8px 8px 0px !important;
        }
      }
    }
    .ant-tabs-content-holder {
      .ant-tabs-content {
        .ant-tabs-tabpane {
          .infinite-engagement-tab {
            /* overflow: hidden !important; */
          }
        }
      }
    }
  }
`;

type AddToNetwork = {
  personId: number;
  personName: string;
  personType: string;
};

const EngagementTab = function EngagementTab() {
  const [activeTab, setActiveTab] = useState('1');
  const { TabPane } = Tabs;
  const dispatch = useDispatch();

  const filters: SRIFilters = useSelector(selectOverviewFilter);

  const myEngagaementCompanyLoading = useSelector(selectMyEngagaementCompanyLoading);
  const myEngagaementPersonLoading = useSelector(selectMyEngagaementPeopleLoading);
  const myEngagaementAlertsLoading = useSelector(selectMyEngagaementAlertsLoading);

  const fetchMoreCompanyLoading = useSelector(selectUserCompanyFetchMoreLoading);
  const fetchMorePersonLoading = useSelector(selectUserPeopleFetchMoreLoading);
  const fetchMoreAlertsLoading = useSelector(selectUserAlertFetchMoreLoading);

  const myEngagementCompniesHeaders = useSelector(selectMyEngagementHeadersContainerCompanies);
  const myEngagementPeopleHeaders = useSelector(selectMyEngagementHeadersContainerPeople);
  const myEngagementAlertsHeaders = useSelector(selectMyEngagementHeadersContainerAlerts);

  const myEngagementCompniesDetails = useSelector(selectMyEngagementDetailContainerCompanies);
  const myEngagementPeopleDetails = useSelector(selectMyEngagementDetailContainerPeople);
  const myEngagementAlertsDetails = useSelector(selectMyEngagementDetailContainerAlerts);
  const popup: AddCompanyPopup = useSelector(selectPopup);

  const hasmoreCompany = useSelector(selecthasMoreCompany);
  const hasmorePeople = useSelector(selecthasMorePeople);
  const hasmoreArticle = useSelector(selecthasMoreAlert);

  const companiesDetails = myEngagementCompniesDetails?.[0];
  const companiesData: SRICompanyDetails[] = companiesDetails?.results as SRICompanyDetails[];
  const peopleDetails = myEngagementPeopleDetails?.[0];
  const peopleData: SRIPersonDetails[] = peopleDetails?.results as SRIPersonDetails[];
  const contentDetails = myEngagementAlertsDetails?.[0];
  const contentData: SRIContentDetails[] = contentDetails?.results as SRIContentDetails[];

  const companiesHeaders = myEngagementCompniesHeaders?.[0];
  const peopleHeaders = myEngagementPeopleHeaders?.[0];
  const contentHeaders = myEngagementAlertsHeaders?.[0];

  const headersData = [companiesHeaders, peopleHeaders, contentHeaders]
    .filter((header) => header !== undefined);

  const initialLoading = myEngagaementCompanyLoading || myEngagaementPersonLoading
    || myEngagaementAlertsLoading;

  const getFormObject = (
    type: string,
    sections: string,
    filter: SRIFilters,
    filterType?: string,
    offset?: number,
  ) => ({
    __TYPE__: type,
    ...(filterType ? { filterType } : {}),
    sections,
    filters: [{ type, ...filter }],
    ...(offset ? { offset } : {}),
  });

  useEffect(() => {
    if (filters.start_date !== '' && filters.end_date !== '') {
      const startTime = getCurrentTime();
      SRI_FILTER_TYPES_USER.forEach((filterType) => {
        dispatch(SRIActions.getSRIMyEngagement(getFormObject('engagement_details', 'MY ENGAGEMENT', filters, filterType)));
      });

      dispatch(flurryActions.callFlurryEvent(
        valueToObject(
          'sri_my_engagement_loaded',
          startTime,
          getFormObject('engagement_details', 'MY ENGAGEMENT', filters),
        ),
      ));
    }
  }, [filters]);

  const fetchMore = () => {
    const startTime = getCurrentTime();
    let filterType = 'company';
    let finalOffset = companiesData?.length;

    if (activeTab === '2') {
      filterType = 'person';
      finalOffset = peopleData?.length;
    } else if (activeTab === '3') {
      filterType = 'article';
      finalOffset = contentData?.length;
    }

    dispatch(SRIActions.getSRIMyEngagement(getFormObject('engagement_details', 'MY ENGAGEMENT', filters, filterType, finalOffset)));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(
        'sri_my_engagement_loaded',
        startTime,
        getFormObject('engagement_details', 'MY ENGAGEMENT', filters, filterType, finalOffset),
      ),
    ));
  };

  const addToNetwork = ({ personId, personType, personName }: AddToNetwork) => {
    const obj: UpdatePersonProfileFollow = {
      personId,
    } as UpdatePersonProfileFollow;
    obj.person_data = [{
      type: personType,
      query: personName,
      entity_id: personId,
    }];
    dispatch(SRIActions.addPersonToNetwork(obj));
  };

  const addCompanyToNetwork = (companyId: number) => {
    const data = { companyId: `${companyId}` };
    dispatch(SRIActions.addCompany(data));
  };

  const addToFavorite = (articleId: number) => {
    const data = { articleId, favoriteFlag: 1 };
    dispatch(FavouriteActions.addToFavorite(data));
  };

  return (
    <Wrapper>
      {popup.showPlanPopup >= 0
        && (
          <ProfilePopups
            isSRICompany
            title={popup.popupHeading}
            description={popup.popupText}
            type={popup.showPlanPopup}
            callToAction={popup.callToAction}
            contactUs={`${popup.contactUsEmail}`}
            isDownloadPopup={false}
            loading={false}
          />
        )}
      {initialLoading
        ? (
          <Row gutter={[16, 16]} className="mt-c-50">
            {[1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map(() => <Col span={8}><SkeletonCustom height="90px" width="100%" /></Col>)}
          </Row>
        )
        : (
          <>
            {headersData?.length > 0 && (
              <Row gutter={[16, 16]}>
                {headersData?.map((header) => (
                  <Col span={8}>
                    <EngagementTitle
                      key={`${header?.category}_${header?.unique_views}`}
                      primaryHeading={header?.title}
                      secondaryHeading={header?.category === 'article' ? 'Articles Viewed' : 'Total Views'}
                    />
                    <EngagementProfileStats
                      key={`${header?.title}_${header?.total_views}`}
                      uniqueView={header?.category === 'article' ? header?.unique_views : header?.unique_views}
                      totalView={header?.category === 'article' ? header?.article_views : header?.total_views}
                      downloadProfile={header?.total_downloads}
                      articleShare={header?.category === 'article' ? header?.article_shares : 0}
                      hideDownloads={header?.category === 'article'}
                      isArticle={header?.category === 'article'}
                    />
                  </Col>
                ))}
              </Row>
            )}
            <Tabs
              type="card"
              className="c-tabs engagement-child-tabs"
              activeKey={activeTab}
              onChange={(key) => setActiveTab(key)}
            >
              {
                companiesData?.length > 0
                && (
                  <TabPane tab={companiesDetails?.title} key="1">
                    <EngagementCompanyTableHeader />
                    <InfiniteScroll
                      dataLength={companiesData.length}
                      next={fetchMore}
                      hasMore={hasmoreCompany}
                      loader={false}
                      className="infinite-engagement-tab"
                    >
                      {
                        companiesData?.map((company) => (
                          <EngagementCompanyTableBody
                            companyId={company?.companyId}
                            persona="#F0B520"
                            image={company?.companyLogo}
                            title={company?.companyName}
                            actionAddBtn={() => addCompanyToNetwork(company?.companyId)}
                            wrapperColor={company?.companyPersonality || [{ color: '#747474' }] as PersonalityTypes[]}
                            subscribed={company?.subscribed}
                            views={company?.views}
                            key={`${company?.companyId}_${company?.companyName}`}
                            downloads={company?.downloads}
                            executiveSubscribed={company?.company_subscribed_execs}
                          />
                        ))
                      }
                      {
                        fetchMoreCompanyLoading ? <DocumentHubTableSkeleton customClassName="sriEngagementSkeleton" /> : null
                      }
                    </InfiniteScroll>
                  </TabPane>
                )
              }
              {
                peopleData?.length > 0
                && (
                  <TabPane tab={peopleDetails?.title} key="2">
                    <EngagementPeopleTableHeader />
                    <InfiniteScroll
                      dataLength={peopleData.length}
                      next={fetchMore}
                      hasMore={hasmorePeople}
                      loader={false}
                      className="infinite-engagement-tab"
                    >
                      {
                        peopleData?.map((person) => (
                          <EngagementPeopleTableBody
                            personId={person?.personId}
                            title={person?.personName}
                            image={person?.personImage}
                            companyId={person?.companyId}
                            companyName={person?.companyName}
                            actionAddBtn={() => addToNetwork({
                              personId: person?.personId,
                              personType: person?.personType,
                              personName: person?.personName,
                            })}
                            wrapperColor={person?.personalityTypes}
                            subscribed={person?.personAdded}
                            views={person?.views}
                            downloads={person?.downloads}
                            persona={person?.personalityTypes
                              && person.personalityTypes.length > 0
                              ? person.personalityTypes[0].color : '#747474'}
                            personType={person?.personType}
                          />
                        ))
                      }
                      {
                        fetchMorePersonLoading ? <DocumentHubTableSkeleton customClassName="sriEngagementSkeleton" /> : null
                      }
                    </InfiniteScroll>
                  </TabPane>
                )
              }
              {
                contentData?.length > 0
                && (
                  <TabPane tab={contentDetails?.title} key="3">
                    <EngagementContentTableHeader />
                    <InfiniteScroll
                      dataLength={contentData.length}
                      next={fetchMore}
                      hasMore={hasmoreArticle}
                      loader={false}
                      className="infinite-engagement-tab"
                    >
                      {contentData?.map((article) => (
                        <EngagementContentTableBody
                          title={article?.title}
                          articleId={article?.articleId}
                          articleImg={article?.image}
                          actionAddBtn={() => addToFavorite(article?.articleId)}
                          categoriesText={(article?.alerts && article?.alerts.length > 0
                            && article.alerts[0].alert) || ''}
                          categoriesColor={(article?.alerts && article?.alerts.length > 0
                            && article.alerts[0].color) || ''}
                          viewsCount={article?.views}
                          sharesCount={article?.shares}
                          isFavorite={article?.isFavorite}
                          articleLink={article?.url}
                          date={article?.date}
                          domain={article?.domain}
                          url={article.url}
                          alertId={(article?.alerts && article?.alerts.length > 0
                            && article.alerts[0].alertid) || 0}
                        />
                      ))}
                      {
                        fetchMoreAlertsLoading ? <DocumentHubTableSkeleton customClassName="sriEngagementSkeleton" /> : null
                      }
                    </InfiniteScroll>
                  </TabPane>
                )

              }
            </Tabs>
          </>
        )}

    </Wrapper>
  );
};

export default EngagementTab;
